import React, { useEffect, useState } from "react";

const HandoverFlowModal = ({ open, selectedCount = 0, onClose, onConfirm, loading = false }) => {
  const [step, setStep] = useState("form"); // 'form' | 'confirm'
  const [pocName, setPocName] = useState("");
  const [pocContact, setPocContact] = useState("");
  const [issuedByName, setIssuedByName] = useState("");
  const [phoneError, setPhoneError] = useState("");

  useEffect(() => {
    if (open) {
      setStep("form");
      setPocName("");
      setPocContact("");
      setIssuedByName("");
      setPhoneError("");
    }
  }, [open]);

  const validatePhone = (phone) => {
    const phoneRegex = /^[0-9]{10}$/;
    if (!phone) {
      return "Phone number is required";
    }
    if (!phoneRegex.test(phone)) {
      return "Please enter a valid 10-digit phone number";
    }
    return "";
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPocContact(value);
    setPhoneError(validatePhone(value));
  };

  if (!open) return null;

  if (step === "form") {
    return (
      <>
        <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Handover Record</h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
              </div>
              <div className="modal-body">
                <div className="text-muted mb-3" style={{ fontFamily: "Lato", color: "#6B7280", fontSize:"14px" }}>{selectedCount} Users Selected</div>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    const phoneValidation = validatePhone(pocContact);
                    if (phoneValidation) {
                      setPhoneError(phoneValidation);
                      return;
                    }
                    setStep("confirm");
                  }}
                >
                  <div className="mb-3">
                    <label className="form-label">Receiver's Name</label>
                    <input
                      type="text"
                      className="form-control input-control"
                      placeholder="Enter Receiver's Name"
                      value={pocName}
                      onChange={(e) => setPocName(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Receiver's Contact</label>
                    <input
                      type="tel"
                      className={`form-control input-control ${phoneError ? 'is-invalid' : ''}`}
                      placeholder="Enter 10-digit Contact Number"
                      value={pocContact}
                      onChange={handlePhoneChange}
                      maxLength="10"
                    />
                    {phoneError && (
                      <div className="invalid-feedback">
                        {phoneError}
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Issued By</label>
                    <input
                      type="text"
                      className="form-control input-control"
                      placeholder="Enter Issued By name"
                      value={issuedByName}
                      onChange={(e) => setIssuedByName(e.target.value)}
                    />
                  </div>
                  <div className="text-center">
                <button type="submit" className="btn btn-primary" disabled={loading || !pocName || !pocContact || !issuedByName || selectedCount === 0 || phoneError}>
                      {loading ? 'Processing...' : 'Handover'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" />
      </>
    );
  }

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Handover Record</h5>
              <button type="button" className="btn-close" aria-label="Close" onClick={onClose} disabled={loading} />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <div className="text-muted" style={{fontFamily:"Lato",fontWeight:400,fontSize:"16px",lineHeight:"150%", color:"#6B7280"}}>Receiver's Name</div>
                <div style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#2D3747"}}>{pocName || "-"}</div>
              </div>
              <div className="mb-4">
                <div className="text-muted" style={{fontFamily:"Lato",fontWeight:400,fontSize:"16px",lineHeight:"150%", color:"#6B7280"}}>Receiver's Contact</div>
                <div style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#2D3747"}}>{pocContact || "-"}</div>
              </div>
              <div className="mb-4">
                <div className="text-muted" style={{fontFamily:"Lato",fontWeight:400,fontSize:"16px",lineHeight:"150%", color:"#6B7280"}}>Issued By</div>
                <div style={{fontFamily:"Lato",fontWeight:400,fontSize:"14px",lineHeight:"150%", color:"#2D3747"}}>{issuedByName || "-"}</div>
              </div>
              <div className="text-center">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    if (onConfirm) onConfirm(pocName, pocContact, issuedByName);
                  }}
                  disabled={loading}
                >
                  {loading ? 'Processing...' : 'Confirm'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
      {loading && (
        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ background: 'rgba(255,255,255,0.6)' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
    </>
  );
};

export default HandoverFlowModal;
